export const LOAD_SERVICES = 'load_agronomy_agreement_services';
export const SERVICES_LOADED = 'set_loaded_agronomy_agreement_services';
export const RESET_SERVICES = 'reset_agronomy_agreement_services';
export const SYNC_FAILED = 'agronomy_agreement_services_sync_error';
